import levelTwokImage from '../../constants/imageFiles/levelTwokImage.jpeg';
import { Grid } from '@mui/material'
import AnswerBox from '../AnswerBox';

export default function LevelTwok() {
    console.log("He's friends with a pickle.")
    return (
        <div>


            <Grid container spacing={1} alignItems='center' justifyContent="center">
                <Grid item xs={9}>
                    <img
                        style={{ maxWidth: "100%" }}
                        src={levelTwokImage}
                        alt="A toddler with spikey red hair, looking scared."
                    />
                </Grid>
            </Grid>
            <br></br>
            < AnswerBox 
                            correctAnswer = 'chuckie'
                            hint = {<div>I'm scared. Real scared.</div>}
                            nextLevel = '../levels/level2l'
                            />
        </div>
    )
};